<template>
<div class="chapter">
<div class="inner_page">
<div class="regions ">
</div>
<div class="regions fm_default">
<div class="region fm_title">
<p>A Simple Guide to Luke</p>
<br class="blank"/>
</div>
</div>
<div class="regions fm_bottom">
<div class="region fm_title">
<p>A Simple Guide to Luke</p>
</div>
<div class="region fm_subtitle">
<p></p>
</div>
<div class="region fm_author">
<p>Paul J. McCarren, SJ</p>
</div>
<div class="region fm_break_logo"></div>
<div class="region fm_logo">
<span class="image"><img alt="" src="images/31-logo_SheedWard.tif.png"/></span>
<br/>
<p><span class="smc">A Sheed &amp; Ward Book</span></p>
<br/>
<p>ROWMAN &amp; LITTLEFIELD PUBLISHERS, INC.</p>
<p>Lanham • Boulder • New York • Toronto • Plymouth, UK</p>
</div>
</div>
<div class="regions copyright">
<div class="region fm_publisher">
<p>A Sheed &amp; Ward Book</p>
<br/>
<p>Published by Rowman &amp; Littlefield Publishers, Inc.</p>
<p>A wholly owned subsidiary of The Rowman &amp; Littlefield Publishing Group, Inc.</p>
<p>4501 Forbes Boulevard, Suite 200, Lanham, Maryland 20706</p>
<p>www.rowman.com</p>
<br/>
<p>10 Thornbury Road, Plymouth PL6 7PY, United Kingdom</p>
<br/>
<p>Copyright © 2013 by Paul J. McCarren</p>
<br/>
<p>
<i>All rights reserved.</i> No part of this book may be reproduced in any form or by any electronic or mechanical
               means, including information storage
               		and retrieval systems, without written permission from the publisher, except by
               a reviewer who may quote passages in a review.
               	
            </p>
<br/>
<p>British Library Cataloguing in Publication Information Available</p>
<br/>
</div>
<div class="region fm_cip">
<p><b>Library of Congress Cataloging-in-Publication Data</b></p>
<br/>
<p>McCarren, Paul J., 1943–</p>
</div>
<div class="region fm_cip">
<p>A simple guide to Luke / Paul J. Mccarren.</p>
</div>
<div class="region fm_cip">
<p>p. cm.</p>
<p>“A Sheed &amp; Ward book.”</p>
</div>
<div class="region fm_cip">
<p>Includes index.</p>
<p>ISBN 978-1-4422-1881-9 (cloth : alk. paper)—ISBN 978-1-4422-1882-6 (pbk. : alk. paper)—ISBN
               978-1-4422-1883-3 (electronic)
            </p>
</div>
<div class="region fm_cip">
<p>1.  Bible. N.T. Luke—Commentaries.  I. Title. </p>
</div>
<div class="region fm_cip">
<p>BS2595.53.M34 2013</p>
<p>226.4'077—dc23</p>
<p>2012031567</p>
<br/>
</div>
<div class="region ">
<p>
<span class="image"><img alt="" src="images/32-logo_tm.png"/></span>
               		The paper used in this publication meets the minimum requirements of American National
               Standard for Information Sciences Permanence of Paper for 
               		Printed Library Materials, ANSI/NISO Z39.48-1992.
               	
            </p>
<br/>
<p>Printed in the United States of America</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 1A01titlepage_frontmatter.vue?fbe1bda8